import React, { useState, useRef, useEffect } from 'react'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavLink,
  NavbarBrand,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap'
import { NavLink as Link } from 'react-router-dom'
import { AzureAD, AuthenticationState } from 'react-aad-msal'
import { throttle } from 'lodash'
import { authProvider } from '../../../services/authProvider'
import store from '../../../store/configureStore'
import logo from '../Logo.png'
import InstallPWA from './InstallPWA'

const Navigation = (props) => {
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)
  const [navBackground, setNavBackground] = useState(false)
  const navRef = useRef()
  navRef.current = navBackground
  useEffect(() => {
    const handleScroll = () => {
      const show = window.scrollY > 60
      if (navRef.current !== show) {
        setNavBackground(show)
      }
    }
    document.addEventListener('scroll', throttle(handleScroll, 100))
    return () => {
      document.removeEventListener('scroll', throttle(handleScroll, 100))
    }
  }, [])

  return (
    <AzureAD provider={authProvider} reduxStore={store}>
      {({ login, logout, authenticationState, accountInfo }) => {
        const isInProgress = authenticationState === AuthenticationState.InProgress

        let isAdmin = false
        let isSales = false
        let isSuperUser = false

        if (accountInfo && accountInfo.account && accountInfo.account.idToken && accountInfo.account.idToken.roles) {
          if (accountInfo.account.idToken.roles.includes('Admin')) {
            isAdmin = true
            isSuperUser = true
          }
          if (accountInfo.account.idToken.roles.includes('Sales')) {
            isSales = true
            isSuperUser = true
          }
          if (accountInfo.account.idToken.roles.includes('ITManager')) {
            isSuperUser = true
          }
        }
        return (
          <Navbar
            color={navBackground ? 'dark' : 'primary'}
            dark
            expand="md"
            className="fixed-top"
            style={{ transition: '0.5s ease' }}
          >
            <NavbarBrand>
              <img style={{ marginRight: '1rem' }} height={30} src={logo} alt="OSIT" />
              User Manager
            </NavbarBrand>
            <NavbarToggler className="navButton" onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
              <Nav className="mr-auto" navbar style={{ display: 'contents' }}>
                {isAdmin && (
                  <NavItem className="nav-link">
                    <Link className="inactiveNav" activeClassName="activeNav" to="/Create">
                      Create
                    </Link>
                  </NavItem>
                )}
                <NavItem className="nav-link">
                  <Link className="inactiveNav" activeClassName="activeNav" to="/Companies">
                    Companies
                  </Link>
                </NavItem>
                {isSuperUser && (
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret className="inactiveNav" activeClassName="activeNav">
                      Reconciliations
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem className="inactiveNav" activeClassName="activeNav">
                        <Link to="/Reconciliation">Managed Reconciliation</Link>
                      </DropdownItem>
                      <DropdownItem className="inactiveNav" activeClassName="activeNav">
                        <Link to="/EssentialsReconciliation">Essentials Reconciliation</Link>
                      </DropdownItem>
                      <DropdownItem className="inactiveNav" activeClassName="activeNav">
                        <Link to="/365BackupReport">365 Backup Reconciliation</Link>
                      </DropdownItem>
                      <DropdownItem className="inactiveNav" activeClassName="activeNav">
                        <Link to="/ThreatlockerRecon">Threatlocker Reconciliation</Link>
                      </DropdownItem>
                      {(isAdmin || isSales) && (
                        <DropdownItem className="inactiveNav" activeClassName="activeNav">
                          <Link to="/KeeperRecon">Keeper Reconciliation</Link>
                        </DropdownItem>
                      )}
                      {(isAdmin || accountInfo?.account?.idToken?.roles?.includes('Sales')) && (
                        <DropdownItem className="inactiveNav" activeClassName="activeNav">
                          <Link to="/CSPRenewals">CSP Renewals</Link>
                        </DropdownItem>
                      )}
                      {(isAdmin || isSales) && (
                        <DropdownItem className="inactiveNav" activeClassName="activeNav">
                          <Link to="/SasbossDid">SASBOSS DID Numbers</Link>
                        </DropdownItem>
                      )}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}

                {isAdmin && (
                  <React.Fragment>
                    <UncontrolledDropdown nav inNavbar>
                      <DropdownToggle nav caret className="inactiveNav" activeClassName="activeNav">
                        Jobs
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem className="inactiveNav" activeClassName="activeNav">
                          <a href="/hangfire">Hangfire Dashboard</a>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                    <UncontrolledDropdown nav inNavbar>
                      <DropdownToggle nav caret className="inactiveNav" activeClassName="activeNav">
                        Admin
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem className="inactiveNav" activeClassName="activeNav">
                          <Link to="/Approvals">Approvals</Link>
                        </DropdownItem>
                        <DropdownItem className="inactiveNav" activeClassName="activeNav">
                          <Link to="/Unsynced">Unsynced Companies</Link>
                        </DropdownItem>
                        <DropdownItem className="inactiveNav" activeClassName="activeNav">
                          <Link to="/ProductMapping">Product Mappings</Link>
                        </DropdownItem>
                        <DropdownItem className="inactiveNav" activeClassName="activeNav">
                          <a href="/api/index.html">API Documentation</a>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </React.Fragment>
                )}

                {isSuperUser && (
                  <NavItem className="nav-link">
                    <Link className="inactiveNav" activeClassName="activeNav" to="/EmailReport">
                      Email Reports
                    </Link>
                  </NavItem>
                )}
              </Nav>
              <Nav className="rightNav ml-auto" navbar>
                {authenticationState === AuthenticationState.Authenticated ? (
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle color="white" nav caret>
                      {accountInfo.account.userName}
                    </DropdownToggle>
                    <DropdownMenu right>
                      <InstallPWA />
                      <DropdownItem onClick={logout}>Log Out</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                ) : (
                  <NavItem>
                    <NavLink color="white" onClick={login} disabled={isInProgress}>
                      Log In
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
            </Collapse>
          </Navbar>
        )
      }}
    </AzureAD>
  )
}

export default Navigation
